import React from 'react';
import PropTypes from 'prop-types';

const IntroSection = ({ title, children, sectionClass = '' }) => {
  return (
    <section className={`intro ${sectionClass}`}>
      <img
        className="divewire-logo"
        src="https://d12v9rtnomnebu.cloudfront.net/press-release/landing-page-images/divewire-logo-create.png"
        alt="Dive/Wire logo"
      />
      <h1 className="display-heading-03">{title}</h1>

      <div className="subheader-text">{children}</div>
    </section>
  );
};

IntroSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  sectionClass: PropTypes.string,
};

export default IntroSection;
